import { useEffect, useRef, useState } from 'react'
import { SIDRender, SListTabs, SLowcodeList, STriggerModal } from 'shj-components'
import config from './dataConfig'
import todayConfig from './todayConfig'
import { appointmentPage } from '@/services/saleOpServices'
import { apiData2Table } from '@/utils/data'
import { useNavigate } from 'react-router-dom'
import wx_add from '@/assets/wx_add.svg'
import wx_add_ok from '@/assets/wx_add_ok.svg'
import CheckThePhone from "@/components/CheckThePhone";
import {openInNewTab} from "@/utils/queryParse.ts";

const dataModal = props => {
  const navigate = useNavigate()
  const { open, onClose } = props
  const listRef = useRef<any>()
  const listRef1 = useRef<any>()
  const listRef2 = useRef<any>()
  const [activeKey, setActiveKey] = useState('todayAppointment')
  
  useEffect(() => {
    setActiveKey(props.activeKey)
  }, [props.activeKey]);
  useEffect(() => {
    if (activeKey !== null) {
      if(activeKey === 'todayAppointment') {
        listRef.current?.reload()
      } else if(activeKey === 'todayArrived') {
        listRef1.current?.reload()
      } else {
        listRef2.current?.reload()
      }
    }
  }, [activeKey]);

  const fetchList = ({current,pageSize}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const query = { "appointmentDateType": activeKey }
        appointmentPage({params: {pageId: current, pageSize}, data: query}).then((data: any) => resolve(apiData2Table(data)))
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const onChangeTab = (key) => {
    setActiveKey(key)
  }
  const extension = {
    request: { fetchList },
    customRender: {
      clueIdRender(text: any, record: any, index: any) {
        const label = text
        return (
          <SIDRender
            id={label}
            onClick={() => {
              openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record.id}`)
            }}
          />
        )
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <CheckThePhone
                clueId={record.id}
                initValue={text}
                auth="salesWorkBenchClueViewPhone"
            />
        )
        //   salesWorkBench
      },
      nameRender(v, record) {
        return <div style={{ display: 'flex' }}>
          <img style={{ width: 20, height: 20, marginRight: 5 }} src={record.salesAddQvFlag ? wx_add_ok : wx_add} />
          {v}
        </div>
      }
    },
  }
  const items = [
    {
      key: 'todayAppointment',
      label: '今日未到店',
      children: <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} rowKey={'id'} />,
    },
    {
      key: 'todayArrived',
      label: '今日已到店',
      children: <SLowcodeList searchMode={'group'} config={todayConfig} ref={listRef1} {...extension} rowKey={'id'} />,
    },
    {
      key: 'tomorrowAppointment',
      label: '明日预约',
      children: <SLowcodeList searchMode={'group'} config={config} ref={listRef2} {...extension} rowKey={'id'} />,
    },
  ]
  return (
    <STriggerModal width={1200} title={'到店客户'} open={open} onCancel={onClose} footer={null}>
      <SListTabs items={items} hideExtra={false} auth={false} activeKey={activeKey} onChange={(key) => onChangeTab(key)} />
    </STriggerModal>
  )
}

export default dataModal
